import React, { useEffect, useState } from "react";
import styles from "./Signup.module.scss";
import { get } from "lodash";
import { Button } from "../Button/Button";
import show from "../../assets/icons/show.svg";
import SVG from "react-inlinesvg";
/* Translations */
import { tr } from "../../utils/translations/translator";
import { useTranslation } from "react-i18next";
//Redux
import { LoginState } from "../../store/login/reducer";
import { RootState } from "../../store";
import { loginActions } from "../../store/login/actions";
import { RouteComponentProps, withRouter } from "react-router";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getUserIP } from "../Shops/shared/__providers__/IPFetcherProvider";

export interface SignupProps extends RouteComponentProps {
  appboy: any;
  loginState: LoginState;
}
interface DispatchProps {
  actions: {
    signupRequest: (
      email: string,
      password: string,
      country: string,
      currency: string
    ) => void;
  };
}
export const Signup: React.FC<SignupProps & DispatchProps> = ({
  actions,
  loginState,
}) => {
  const [email, setEmail] = useState<string>("");

  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [check, setChecked] = useState<boolean>(false);
  const [currency, setCurrency] = useState<string>("EUR");
  const [country, setCountry] = useState<string>("ES");

  useEffect(() => {
    getUserIP()
      .then((res: any) => {
        const ip = get(res, "ip");
        ip && onSuccess(res);
      })
      .catch(() => onError());
  }, []);
  const onSuccess = (data: any) => {
    const currency = get(data, ["currency", "code"]);
    const country = get(data, ["country_code"]);
    currency && setCurrency(currency);
    country && setCountry(country);
  };
  const onError = () => {
    setCurrency("USD");
    console.log("Error: no ip available");
  };

  const { t } = useTranslation();

  const handleOnSubmit = () => {
    actions.signupRequest(email, password, country, currency);
  };

  return (
    <div className={styles.wrapper}>
      {loginState.user && loginState.user.user ? (
        <div className={styles.container}>
          <h2>
            Welcome to
            <br></br> TipsterChat
          </h2>
        </div>
      ) : (
        <div className={styles.container}>
          <h2>
            {tr(t, "signup_title")}
            <br></br> TipsterChat
          </h2>
          <div className={styles.inputs}>
            <input
              type="email"
              className={styles.input}
              onChange={(text: any) => setEmail(text.target.value)}
              placeholder={tr(t, "email-address")}
            />
            <div className={styles.passWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                min={6}
                className={styles.input}
                onChange={(text: any) => setPassword(text.target.value)}
                placeholder={tr(t, "password")}
              />
              <button
                className={showPassword ? styles.active : styles.unactive}
                type="button"
                onClick={() => setShowPassword(!showPassword)}
              >
                <SVG src={show} />
              </button>
            </div>

            <div className={styles.termsAndConditions}>
              <div
                className={`${styles.checkbox} ${
                  check ? `${styles.checked}` : ""
                }`}
                onClick={() => setChecked(!check)}
              >
                {check ? "✓" : ""}
              </div>
              <div>
                {t("accept-the")}{" "}
                <a href="/terms" className={styles.termsRef}>
                  {t("terms-and-conditions")}
                </a>
              </div>
            </div>
          </div>

          <div className={styles.buttons}>
            <Button
              className={styles.signupButton}
              type="button"
              disabled={!email.length || !password.length || !check}
              action={handleOnSubmit}
              text={tr(t, "signup")}
              theme={"primary"}
            />
          </div>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  loginState: state.login,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      signupRequest: loginActions.signupRequestAction,
    },
    dispatch
  ),
});

export const SignupConnected = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Signup)
);
